import React from "react";
import "./herobanner.css";
import { useEffect,useState,useRef } from "react";
import {  Typography } from "@mui/material";

import Card from "../Card/card";
import FrontendApp from "../../pages/OttFrontend";
import AOS from 'aos';
import 'aos/dist/aos.css';
// import heroVideo from "../../assets/aboutus/Enhance_Video_Quality_and_Remove_Logo.mp4"

const HeroBanner = () => {
    const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlayPause = () => {
    const video = videoRef.current;

    if (!video) return;

    if (isPlaying) {
      video.pause();
      setIsPlaying(false);
    } else {
      video.play();
      setIsPlaying(true);
    }
  };

 useEffect(() => {
    AOS.init({
      duration: 1200,       // Animation duration in ms
      once: true,           // Whether animation should happen only once
      offset: 200,          // Offset (in px) from the original trigger point
    });
  }, []);



  return(
  <div className="wcontainer1" >
    <div className="wrapper ">
      <div className="wrapper-group-visuals">
        <div >
              <video 
          src="https://d20mfvycw28oia.cloudfront.net/WebsiteVideo/Final_cut_hbb.webm"
          alt="Hero Banner"
           ref={videoRef}
          id="hero-video"
          className="hero-image"
          height="500px"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        </div>

        <div className="text-overlay">
          <div className="book-demo">
            <button className="pauseButton" onClick={togglePlayPause}>
  {isPlaying ? "Pause" : "Play"}
</button>
            <a
              className="elementor-button elementor-button-link elementor-size-sm"
              href="mailto:ottsales@horizonind.org?subject=Book%20A%20Demo"
            >
              <button variant="outlined" className="demo-btn">
                Book a Demo
              </button>
            </a>
          </div>
        </div>
      </div>
      <div
        className="relative z-10 w-full"
        style={{
          margin: "10px",
          perspective: "700px",
          maxWidth: "100%",
          // background: 'linear-gradient(to top, rgba(103, 58, 183, 0.6) 0%, rgb(167 167 167 / 14%) 50%)',
          padding: "20px",
          borderRadius: "10px",
          // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Typography data-aos="fade-up"
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "39px",
            fontWeight: "800",
            fontFamily: "system-ui",
            // borderBottom: "2px solid #9ca3af"
            color: "#6054E4",
          }}
        >
          Our Products
        </Typography>
        {/* <p
          className="product-text"
          style={{ fontSize: "24px" }}
        >
          We design, Develop and Integrate Multiscreen Solutions.
        </p> */}
        <Card />
      </div>
      <div className="relative z-10 w-full" >
        <FrontendApp />
      </div>
      {/* <div className="mission-container">
        <div className="mission">
          <h3>Our Milestones</h3>
        </div>
        <div className="group">
          <div className="g">
            <h3 className="g-title color-[#555555]">1.5m</h3>
            <p>SmartTV</p>
          </div>
          <div className="g">
            <h3 className="g-title color-[#555555]">5m</h3>
            <p> Mobile</p>
          </div>
          <div className="g">
            <h3 className="g-title color-[#555555]">0.5m</h3>
            <p>SetTop Box/Dongle</p>
          </div>
        </div>
      </div> */}
    </div>
  </div>
)
}


export default HeroBanner;
